import { Award, Clock, MapPin, ShieldCheck, ThumbsUp, Wallet } from "lucide-react";
import Reveal from "@/components/SectionReveal";

const ITEMS = [
  {
    icon: Award,
    title: "25+ Years Experience",
    text: "Decades of hands-on pool experience across every system type and Florida weather pattern.",
  },
  {
    icon: ShieldCheck,
    title: "Licensed & Insured",
    text: "Fully insured pros with safe, professional handling of your pool and property.",
  },
  {
    icon: Clock,
    title: "24/7 Pool Emergency",
    text: "Pump failure, leaks, storm damage — call any time and we respond fast.",
  },
  {
    icon: MapPin,
    title: "Local Tampa Bay Pros",
    text: "Established 2020 — we live here, swim here, and answer when you call.",
  },
  {
    icon: Wallet,
    title: "Honest, Flat Pricing",
    text: "Clear quotes, no surprise fees, and weekly plans that actually save you money.",
  },
  {
    icon: ThumbsUp,
    title: "Guaranteed Results",
    text: "If your water isn't crystal clear, we make it right — that's our pro promise.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <Reveal className="max-w-3xl">
          <p className="text-xs tracking-[0.22em] uppercase font-bold text-sky-700">Why Tampa Bay Pool Pros</p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            The friendliest, most reliable pool pros in Tampa Bay.
          </h2>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <Reveal
                key={it.title}
                delay={i * 0.05}
                direction={i % 2 === 0 ? "up" : "left"}
                className="rounded-3xl p-6 bg-gradient-to-br from-white to-sky-50/40 border border-slate-100 shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:-translate-y-1 transition-transform"
                testId={`why-${i}`}
              >
                <div className="w-12 h-12 rounded-2xl bg-amber-50 text-amber-600 inline-flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-4 font-heading text-xl font-bold text-slate-900">{it.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{it.text}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
